module.exports = __webpack_public_path__ + "04_short_brown.24ca0562.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_short_brown.png
// module id = TF5P
// module chunks = 0